var render = function render(){var _vm=this,_c=_vm._self._c;return _c('download-excel',{staticClass:"export-excel-wrapper",attrs:{"data":_vm.DetailsForm,"fields":_vm.json_fields,"name":"卡密.xls"}},[_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.$message.success('正在下载...')}}},[_vm._v("导出")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }